define('viewModels/widgets/audio/AudioPlayerView',[
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'moment',
    'lib/waveform',
    'util/ininAudioUtils',
    'viewModels/widgets/audio/VolumeControlView',
    'services/loggingService',
    'services/toastService',
    'services/userSettingsService',
    'services/qm/qualityAuth',
    'viewModels/privileged/qm/AnnotationView',
    'viewModels/ViewModel'
], function (ko,
             _,
             $,
             moment,
             Waveform,
             audioUtils,
             VolumeControlView,
             loggingService,
             toastService,
             userSettingsService,
             qualityAuthorization,
             AnnotationView,
             ViewModel) {
    'use strict';


    var AudioPlayerView = ViewModel.extend(function (audioUri, audioId, options) {
        var self = this;
        var audioPlayers        = ko.observableArray();

        self.audioId            = ko.observable(audioId);
        self.autoplay           = true;
        self.annotationsList    = ko.observableArray();
        self.isAudioLoaded      = ko.observable(false);
        self.isPlaying          = ko.observable(false);
        self.isSeeking          = ko.observable(false);
        self.annotationViews    = ko.observableArray([]);
        self.percentPosition    = ko.observable(0);
        self.progressDisplay    = ko.observable(0);
        self.durationDisplay    = ko.observable(0);
        self.annotationTextInput = ko.observable('').extend({trimmed: null});
        self.shouldSuggestWebm = audioUtils.shouldSuggestWebm();
        self.reloadCallback     = null;
        self.currentPlaySpeed   = ko.observable(1);

        self.autoPlay = false;
        self.darkMode = false;
        self.showAnnotations = true;

        //Possible options:
        //{
        //  autoPlay            // Disables automatic play on load
        //  reloadCallback:     // Function to call if child view wants to reload the view stack
        //  darkMode:           // Display audioplayer with dark color scheme
        //  showAnnotations:    // Show (or not) the controls for adding annotations
        //}

        _.assign(self,options);

        var canAddAnnotation = qualityAuthorization.canAddAnnotation() && self.showAnnotations;
        self.canAddAnnotation   = ko.observable(canAddAnnotation);
        self.waveformOuterColor = ko.observable("#ffffff");

        if (self.darkMode) {
            self.waveformOuterColor("#252525");
        }

        self.audioChannels = ko.observableArray();
        self.setChannels = function (channels) {
            self.audioChannels(_.map(channels, function (channel, index) {
                if (!channel.audioUri) {
                    loggingService.error("AudioPlayerView set a channel that didn't have an audioUri. " + channel);
                }
                var syncVolumeToUserSettings = channel.syncVolumeToUserSettings != null ? channel.syncVolumeToUserSettings : index === 0;
                channel.volumeControl = self.subView(VolumeControlView, {syncVolumeToUserSettings: syncVolumeToUserSettings});
                channel.index = index;
                return channel;
            }));
        };

        //
        // Public Functions
        //

        self.playPauseClick = function (data, event) {
            if (event) {
                event.preventDefault();
            }

            if (self.isPlaying()) {
                self.pause();
            } else {
                self.play();
            }
        };

        self.play = function () {
            _.each(audioPlayers(), function (audioPlayer, index) {
                audioPlayer.play();
                loggingService.debug("Playing audio channel " + index);
            });
            self.updateIsPlaying();
        };

        self.setSpeed = function (speed) {
            _.each(audioPlayers(), function (audioPlayer) {
                audioPlayer.setSpeed(speed);
            });
            self.updateIsPlaying();
        };

        self.pause = function () {
            _.each(audioPlayers(), function (audioPlayer) {
                audioPlayer.pause();
            });
            self.updateIsPlaying();
        };

        self.stop = function () {
            _.each(audioPlayers(), function (audioPlayer) {
                audioPlayer.stop();
            });
            self.updateIsPlaying();
        };

        self.shouldDrawFromData = self.computed(function () {
            return _.every(self.audioChannels(), function (channel) {
                return channel.waveformData && _.without(channel.waveformData, undefined, null, '').length > 0;
            });
        });

        self.waveformClick = function (percentPosition, event) {
            event.preventDefault();
            if (audioPlayers().length > 0) {
                // All audio players should have matching duration and position.
                var newPosition = audioPlayers()[0].getDuration() * percentPosition;
                if (newPosition > 0) {
                    self.setPositionMs(newPosition);
                }
                self.updatePosition(audioPlayers()[0].getPosition());
            }
        };

        self.setPositionMs = function (positionInMs) {
            if (audioPlayers().length > 0) {
                _.each(audioPlayers(), function (audioPlayer) {
                    // Pause before seeking, but do not "updateIsPlaying"
                    // Then, as soon as all channels can play again, it will resume.
                    audioPlayer.pause();
                    audioPlayer.setPosition(positionInMs);
                });
            }
        };

        self.getDuration = function () {
            if (audioPlayers().length > 0) {
                var audioPlayer = audioPlayers()[0];
                return audioPlayer.getDuration();
            }
            return 0;
        };


        var annotations = function() {
            var lastPercentPosition = 0;

            function showAnnotation(annotation){
                var tooltipDuration = 3000;
                annotation.showTooltip();

                setTimeout(function() {
                    annotation.hideTooltip();
                }, tooltipDuration);
            }

            return {
                doUpdate: function(percentPosition) {
                    _.forEach(self.annotationViews(), function(annotation) {
                        if ((percentPosition - lastPercentPosition) < 100 && lastPercentPosition < annotation.percentPosition() && annotation.percentPosition() < percentPosition) {
                            showAnnotation(annotation);
                        }
                    });

                    lastPercentPosition = percentPosition;
                }
            };
        };

        var annotation = annotations();

        self.updatePosition = function (position) {
            if (audioPlayers().length > 0) {
                var audioPlayer = audioPlayers()[0];
                self.percentPosition(position / audioPlayer.getDuration() * 100);

                if (isNaN(self.percentPosition())) {
                    self.percentPosition(0);
                }

                self.progressDisplay(position);

                annotation.doUpdate(self.percentPosition());
            }
        };

        self.updateIsPlaying = function () {
            if (audioPlayers().length > 0) {
                self.isPlaying(audioPlayers()[0].getIsPlaying());
            }
        };

        var reloadStarted = false;

        self.handleError = function(e) {

            var reload = false;

            switch (e.target.error.code) {

                case e.target.error.MEDIA_ERR_ABORTED:
                    loggingService.debug('Playback aborted.');
                    reload = false;
                    break;
                case e.target.error.MEDIA_ERR_NETWORK:
                    //This is what happens if the item cache goes missing during playback (after a long pause for example)
                    loggingService.debug('A network error caused the audio download to fail.');
                    reload = true;
                    break;
                case e.target.error.MEDIA_ERR_DECODE:
                    loggingService.debug('The audio playback was aborted due to a corruption problem or because the audio used features your browser did not support.');
                    reload = true;
                    break;
                case e.target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                    loggingService.debug('The video audio not be loaded, either because the server or network failed or because the format is not supported.');
                    reload = true;
                    break;
                default:
                    loggingService.debug('An unknown error occurred.');
                    reload = true;
                    break;
            }

            if(reload && !reloadStarted) {
                reloadStarted = true;
                toastService.notifyMessage("playback.recordingPlayback.error.title", {
                    bodyMessageKey: "playback.recordingPlayback.error.msg",
                    messageData: {  },
                    icon: "pc-icon-messages"
                });

                if(self.reloadCallback) {
                    self.reloadCallback();
                }
            }
        };

        self.init = function (audioPlayer, audioChannel, html5Node) {

            if (audioChannel.audioUri) {
                var eventTypes = audioPlayer.eventTypes;

                // event logging
                _.each([
                    eventTypes.CANPLAYTHROUGH,
                    eventTypes.STALLED,
                    eventTypes.SEEKING
                ], function (eventType) {
                    audioPlayer.addListener(eventType, function () {
                        var logLevel = eventType === eventTypes.STALLED ? 'warn' : 'info';
                        loggingService[logLevel]("handling audio " + eventType + " event", {
                            readyState: audioPlayer.getReadyState().toString()
                        });
                    });
                });

                audioPlayer.addListener(eventTypes.READY, function () {
                    audioPlayer.load(audioChannel.audioUri);
                });
                
                audioPlayer.addListener(eventTypes.CANPLAYTHROUGH, function () {
                    var allCanPlay = _.every(audioPlayers(), function (audioPlayer) {
                        // All channels have loaded enough to likely play through
                        // to the end of the file
                        return audioPlayer.getReadyState() == 4;
                    });

                    if (allCanPlay) {
                        self.isSeeking(false);
                        self.isAudioLoaded(true);
                        if (self.autoplay || self.isPlaying()) {
                            self.play();

                            // only autoplay with the initial load
                            self.autoplay = false;
                        }
                        self.updateIsPlaying();
                    }
                });

                // Only listen to time updates on one channel, to smooth out jitters in duration display
                if (audioChannel.index === 0) {
                    audioPlayer.addListener(eventTypes.TIMEUPDATE, function (position) {
                        self.updatePosition(position);
                    });
                }

                audioPlayer.addListener(eventTypes.SEEKING, function () {
                    self.isSeeking(true);
                });

                audioPlayer.addListener(eventTypes.STALLED, function () {
                    self.isAudioLoaded(false);
                });

                audioPlayer.addListener(eventTypes.LOG, function (message) {
                    loggingService.debug(message);
                });

                audioPlayer.addListener(eventTypes.ENDED, function () {
                    self.updatePosition(0);
                    self.updateIsPlaying();
                });
                audioPlayer.init(html5Node, self.mimeType);
                if (audioPlayers().length < 2){
                    audioPlayers.push(audioPlayer);
                }

                self.computed( function () {
                    if (audioChannel.volumeControl) {
                        if (!isNaN(audioChannel.volumeControl.volumeLevel())){
                            audioPlayer.setVolumeLevel(audioChannel.volumeControl.volumeLevel());
                        }
                    } else {
                        loggingService.warn("No volume control for audio channel with uri " + audioChannel.audioUri);
                    }
                });
            }
        };

        //
        // Computed functions
        //
        self.computed(function () {
            if (self.annotationsList() && self.isAudioLoaded()) {
                if (audioPlayers().length > 0) {
                    var audioPlayer = audioPlayers()[0];
                    var duration = audioPlayer.getDuration();
                    self.durationDisplay(duration);
                    updateAnnotations(duration);
                }
            }
        });

        self.subscribe(self.currentPlaySpeed, function (newVal) {
            self.setSpeed(newVal);
        });

        //
        // Private functions
        //
        var updateAnnotations = function (totalAudioDurationInMs) {
            self.annotationViews([]);
            _.each(self.annotationsList(), function (playbackEvent) {

                var location = ko.utils.unwrapObservable(playbackEvent.location);

                if (location <= totalAudioDurationInMs) {

                    //Group together any annotations within 100ms of each other
                    var existingAnnotationView = _.find(self.annotationViews(), function (annotationView) {
                        return Math.abs(annotationView.location() - location) <= 100;
                    });

                    //If there was another annotation view at the same time add it to the existing one
                    //otherwise, create a new one.
                    if(existingAnnotationView) {
                        existingAnnotationView.addAnnotation(playbackEvent);
                    } else {
                        self.annotationViews.push(self.subView(AnnotationView, playbackEvent,
                            totalAudioDurationInMs));
                    }
                }
            });
        };

        /**
         * CLEAN UP
         */
        self.onDispose = function () {
            _.each(audioPlayers(), function (audioPlayer) {
                audioPlayer.reset();
            });
        };

    });

    return AudioPlayerView;
});

